<template>
  <div class="file">
    <van-pull-refresh @refresh="onRefresh" v-model="isLoading">
      <!-- <div class="wrapper"> -->
      <div class="file-content">
        <van-swipe @change="onChange">
          <!-- <v-button  @click="show = true">
                <van-swipe-item>             
                  <img src="https://img.yzcdn.cn/vant/cat.jpeg" alt="">                    
                </van-swipe-item>
               </v-button>
               <van-overlay :show="show" @click="show = false">
                 <div @click.stop>
                    <img src="https://img.yzcdn.cn/vant/cat.jpeg" alt="">
                 </div>
                </van-overlay> -->
          <van-swipe-item v-for="(item, key) in liveimage.image" :key="key">
            <img :src="item.img" alt="" />
          </van-swipe-item>
          <!-- <van-swipe-item><img src="https://img.yzcdn.cn/vant/cat.jpeg" alt=""></van-swipe-item>
              <van-swipe-item><img src="https://img.yzcdn.cn/vant/cat.jpeg" alt=""></van-swipe-item> -->
          <template #indicator>
            <div class="custom-indicator">{{ current + 1 }}/3</div>
          </template>
        </van-swipe>
        <div class="action">
          <v-button @click="show = true">
            <span><van-icon name="shrink" size="24"/></span>
          </v-button>
          <van-overlay :show="show" @click="show = false" v-for="(item, key) in liveimage.image" :key="key">
            <img :src="item.img" alt="" />
          </van-overlay>
        </div>
      </div>
      <!-- </div> -->
      <!--       
        <van-overlay :show="show" @click="show = true">
            <div class="wrapper" @click.stop>
                <div class="file-content">
                  <van-swipe @change="onChange">
                      <van-swipe-item><img src="https://img.yzcdn.cn/vant/cat.jpeg" alt=""></van-swipe-item>
                      <van-swipe-item><img src="https://img.yzcdn.cn/vant/cat.jpeg" alt=""></van-swipe-item>
                      <van-swipe-item><img src="https://img.yzcdn.cn/vant/cat.jpeg" alt=""></van-swipe-item>
                      <van-swipe-item><img src="https://img.yzcdn.cn/vant/cat.jpeg" alt=""></van-swipe-item>
                      <template #indicator>
                        <div class="custom-indicator">
                          {{ current + 1 }}/4
                        </div>
                      </template>
                    </van-swipe>
                </div>
            </div>
        </van-overlay>  -->
      <!-- <van-image-preview v-model="show" :images="images" @change="onChange">
           <template v-slot:index>第{{index}}页</template>
        </van-image-preview> -->
      <!-- <img src="https://img.yzcdn.cn/vant/apple-1.jpg" alt="">
        11111 -->
    </van-pull-refresh>
  </div>
</template>
<script>
import { Toast } from 'vant';
export default {
  name: 'File',
  data() {
    return {
      // show:true,
      show: false,
      index: 0,
      current: 0,
      liveimage: {
        image: [
          { value: '1', img: 'https://img.yzcdn.cn/vant/cat.jpeg' },
          { value: '2', img: 'https://img.yzcdn.cn/vant/apple-1.jpg' },
          { value: '3', img: 'https://img.yzcdn.cn/vant/apple-2.jpg' }
        ]
      },
      isLoading: false
    };
  },
  methods: {
    onChange(index) {
      this.current = index;
    },
    onRefresh() {
      setTimeout(() => {
        Toast('刷新成功');
        this.isLoading = false;
        this.count++;
      }, 1000);
    }
  }
};
</script>
<style lang="less" scoped></style>
